<template>
	<v-dialog v-model="visible" persistent width="500">
		<v-card>
			<v-card-title class="text-h5 grey lighten-2">
				Venta exitosa
			</v-card-title>
			<v-card-text>
				<v-row dense>
					<v-col cols="12" class="d-flex flex-column align-center">
						<v-icon color="success" size="128">
							check_circle
						</v-icon>
						<span>
							La venta asistida ha concluido exitosamente y su identificador de orden es <b>{{ idOrden }}</b>.
						</span>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions class="d-flex justify-end">
				<v-btn @click="nuevaVenta" color="primary" depressed class="ma-1" large :loading="redirigiendo">
					Chévere, hagamos otra
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		'visible': {
			type: Boolean,
			default: false,
		},
		'idOrden': {
			default: undefined,
		},
	},
	data: () => ({
		redirigiendo: false,
	}),
	computed: {
		// Nada
	},
	methods: {
		nuevaVenta: function() {
			let vm = this;
			// Redirigir al usuario al inicio... la URL es la misma durante todo el proceso.
			// Entonces solo recargarle la página para que el usuario comience otra venta desde cero
			const urlActual = window.location.href;
			window.location.href = urlActual;
			// Simular que algo se carga para retroalimentación visual, redirección puede tomar algunos segundos
			vm.redirigiendo = true;
		},
	},
	watch: {
		visible: {
			immediate: true,
			handler: function(newVal) {
				// Nada
			}
		},
	}
};
</script>
